import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { envConfigMap } from "@/hooks/common/fetch/config";
const { RUNTIME_ENV } = process.env;

const { scrmPathMap } = envConfigMap[RUNTIME_ENV];

/**
 * @author zhousj6，20240422
 * @todo 按照iscrm的逻辑，getCountryData接口只部署了欧洲数据中心，调用其它数据中心会报404
 * @returns Promise
 */
export const useCountryApi = async () => {
  return await useScrmFetch(`${scrmPathMap.eu}/web/edm/mbg/common/getCountryData?language=en`).get().json();
}